<div class="success-container w-20 bg-white rounded-5 my-5 shadow-lg text-center">
    <div class="fields-container m-5">
        <div class="success-title text-center mb-4">
            <p class="container-paragraph font-weight-bold fs-4">
                {{ verificationStatus || 'Verifying email...' }}
            </p>
        </div>
        <div class="success-icon mb-4">
            <!-- Success Icon - Show when no error status -->
            <svg *ngIf="!verificationStatus || verificationStatus === 'Verifying email...'" width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_739_60156)">
                    <path
                        d="M12 22.5C17.5228 22.5 22 18.0228 22 12.5C22 6.97715 17.5228 2.5 12 2.5C6.47715 2.5 2 6.97715 2 12.5C2 18.0228 6.47715 22.5 12 22.5Z"
                        stroke="#006538" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M9.5 12.5L11.5 14.5L14.5 11.5" stroke="#006538" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </g>
                <defs>
                    <clipPath id="clip0_739_60156">
                        <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                    </clipPath>
                </defs>
            </svg>
            
            <!-- Error Icon - Red X - Show when there's an error status -->
            <svg  width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_739_60157)">
                    <path
                        d="M12 22.5C17.5228 22.5 22 18.0228 22 12.5C22 6.97715 17.5228 2.5 12 2.5C6.47715 2.5 2 6.97715 2 12.5C2 18.0228 6.47715 22.5 12 22.5Z"
                        stroke="#dc3545" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M8.5 8.5L15.5 15.5" stroke="#dc3545" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M15.5 8.5L8.5 15.5" stroke="#dc3545" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <defs>
                    <clipPath id="clip0_739_60157">
                        <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                    </clipPath>
                </defs>
            </svg>
        </div>
        <div class="success-message mb-4">
            <p class="fs-5">You will be redirected to the login page in a few seconds. If not, click <span
                    (click)="redirectNow()"
                    style="color: blue; text-decoration: underline; cursor: pointer;">here</span>
            </p>
        </div>
    </div>
</div>
